<template>
  <div
    id="inputId"
    :key="key"
    class="lt"
    :class="{ 'label-toggle-disabled': disabled }"
    data-cy="lt-component"
    @click="!disabled && emit('update:modelValue', !props.modelValue)"
  >
    <span class="switch" data-cy="input-switch">
      <input :checked="modelValue" :disabled="disabled" type="checkbox" />
      <span class="slider round"></span>
    </span>
    <label class="ml-1 body-1" data-cy="label">{{ text }}</label>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
// https://vuejs.org/guide/components/v-model.html#under-the-hood
// This was implemented on vue 3.3.4 - not 3.4, we may
// want to switch to the defineModel pattern on upgrade

// PRESERVED FROM PREVIOUS IMPLEMENTATION
// IS THIS REALLY NEEDED OR EVEN A GOOD IDEA?
const key = ref(`LT:${Math.ceil(Math.random() * 10000)}`);

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    text?: string;
    modelValue: boolean;
    inputId?: string;
  }>(),
  {
    disabled: false,
    text: "",
    modelValue: false,
    inputId: ""
  }
);

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
}>();
</script>

<style lang="scss">
.lt {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    user-select: none;
    color: var(--text-color);
    transition: all 0.2s ease-in-out;
    &:hover {
      color: var(--info-300);
    }
  }
}
.label-toggle-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(22px);
  -ms-transform: translateX(22px);
  transform: translateX(22px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
